import { ServiceRequest, Patient } from '@medplum/fhirtypes';
import { ConsentStatus } from '@/types/consent.types';
import { getPatientOrPractitionerName } from './common-helpers';
import { getOrderSubState, getSubStateLabel } from './order-substates-helper';



// ---------------------------------------------------------------------------
export const getConsentStatusForOrder = (
  order: ServiceRequest,
  consentStatuses: Map<string, ConsentStatus>
): ConsentStatus => {
  if (!order.id) {
    return 'not-answered';
  }
  return consentStatuses.get(order.id) || 'not-answered';
};
// ---------------------------------------------------------------------------
export const getPatientNameForOrder = (
  order: ServiceRequest,
  patients: Map<string, Patient>,
  fallbackText: string = 'Unknown'
): string => {
  const patientId = order.subject?.reference?.replace('Patient/', '');
  if (!patientId) {
    return fallbackText;
  }

  const patient = patients.get(patientId);
  if (!patient) {
    return 'Loading...';
  }

  return getPatientOrPractitionerName(patient);
};

// ---------------------------------------------------------------------------
export const getOrderId = (order: ServiceRequest): string => {
  return order.identifier?.[0]?.value || order.id || 'N/A';
};

// ---------------------------------------------------------------------------
export const getTestName = (
  order: ServiceRequest,
  fallbackText: string = 'Unknown Test'
): string => {
  const coding = order.code?.coding?.[0];
  if (!coding?.code) {
    return fallbackText;
  }
  // Use the display from the coding directly, fallback to code if no display
  return coding.display || coding.code;
};

// ---------------------------------------------------------------------------
export const getSubStateName = (
  order: ServiceRequest,
  t: any
): string => {
  const subState = getOrderSubState(order);
  if (!subState) {
    return 'N/A';
  }
  return t(getSubStateLabel(subState));
};

// ---------------------------------------------------------------------------
export const getStatusName = (
  status: string | undefined,
  t: any
): string => {
  if (!status) {
    return 'N/A';
  }
  
  // Only translate the specific status we need
  switch (status) {
    case 'draft':
      return t('orderList.statuses.draft');
    case 'active':
      return t('orderList.statuses.active');
    case 'completed':
      return t('orderList.statuses.completed');
    case 'cancelled':
      return t('orderList.statuses.cancelled');
    case 'on-hold':
      return t('orderList.statuses.onHold');
    default:
      return status;
  }
};
